import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow_back",
  "use": "icon-arrow_back-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-arrow_back\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" />\n\t<path d=\"M24,13.4H5.67l8.6,8.54L12.19,24,0,12,12.17,0l2.11,2.08L5.67,10.49H24Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol